import React from 'react';

import { Card, Form, Button } from 'react-bootstrap';

const SpecialForm = (props) => {


    return (
        <Card>
            <Card.Body>
                <Form>
                    <h5>Add New Special</h5>
                    <hr />
                    <Form.Group>
                        <Form.Label>Special Name</Form.Label>
                        <Form.Control type="text" placeholder="Enter the special name" />
                    </Form.Group>
                    <Form.Group>
                        <Form.Label>Special Image</Form.Label>
                        <Form.Text className="text-muted">Dimension must be 1140x342</Form.Text>
                        <Form.File
                            id="special-img"
                            label="Insert the special image here"
                            custom
                        />
                    </Form.Group>
                    <Button variant="success">Add Special</Button>
                </Form>
            </Card.Body>
        </Card>
    );
};

export default SpecialForm;